import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from './Components/Home/Home';
import { getStoleMetaData } from './services';

import './App.css';
import './carousel.css';

function App() {
  const[stoleMeta, setStoleMeta] = useState();

  const getStoleData = async () => {
    const { data } = await getStoleMetaData();

    if (data) setStoleMeta(data)
  }

  useEffect(() => {
    getStoleData();
  }, []);
   
  return (
    <div>
      {stoleMeta && 
        <BrowserRouter>
          <Switch>
            <Route path="/" component={() => <Home stoleMeta={stoleMeta}/>} />
           <Route path="/review" component={() => <Home stoleMeta={stoleMeta}/>} />
          </Switch>
        </BrowserRouter>
      }
    </div>
  );
}

export default App;
